<script>

export default {
  data () {
    return {
      powerTrendOption: {
        tooltip: {
          trigger: 'axis',
          formatter: function () {
          }
        },
        legend: {
          data: ['A相', 'B相', 'C相', '总'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          x1: 10,
          y2: 40,
          x2: 30
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: 'h',
          data: ['-24', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-20', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-16', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-12', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-8', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-4', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '0']
        }],
        yAxis: [{
          type: 'value',
          name: 'kW',
          axisLabel: {
            // formatter: '{value} %'
          }
        }],
        series: [{
          name: 'A相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00]
        }, {
          name: 'B相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: [7.00, 4.00, 6.00, 1.00, 5.00, 8.00, 3.00]
        }, {
          name: 'C相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: [4.00, 5.00, 2.00, 1.00, 8.00, 5.00, 3.00]
        }, {
          name: '总',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#04404d'
          },
          data: [2.00, 7.00, 3.00, 6.00, 4.00, 9.00, 0.00]
        }
        ]
      },
      powerTrendChart: {},
      // 频段下拉框
      powerTypeSelectOptions: [{
        value: 1,
        label: '有功功率'
      }, {
        value: 2,
        label: '无功功率'
      }, {
        value: 3,
        label: '视在功率'
      }],
      powerTypeSelectValue: 1,
      interval: null,
      lastTs: 0
    }
  },
  watch: {
    powerTypeSelectValue () {
      this.updateData()
    }
  },
  mounted () {
    this.powerTrendChart = this.$echarts.init(document.getElementById('powerTrendChartOptions'))
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: 'meter_stable_data',
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
        })
      }, 1000)
    }
  },

  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    async updateData () {
      var max = 0
      var min = 0x7fffffff
      var tableData = {
        a: 0,
        b: 0,
        c: 0,
        t: 0
      }
      let params = {
        'collection': 'meter_stable_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'num': 97,
        'fields': ['p_pha', 'p_phb', 'p_phc', 'p_total', 'q_pha', 'q_phb', 'q_phc', 'q_total', 's_pha', 's_phb', 's_phc', 's_total'],
        'transpose': true
      }
      const {data: res} = await this.$api.queryLastDatas(params)

      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      console.log(res)
      if (this.powerTypeSelectValue === 1) {
        tableData.a = res.data.p_pha
        tableData.b = res.data.p_phb
        tableData.c = res.data.p_phc
        tableData.t = res.data.p_total

        for (let i = 0; i < res.data.p_pha.length; i++) {
          if (max < tableData.a[i]) max = tableData.a[i]
          if (max < tableData.b[i]) max = tableData.b[i]
          if (max < tableData.c[i]) max = tableData.c[i]
          if (max < tableData.t[i]) max = tableData.t[i]
          if (min > tableData.a[i]) min = tableData.a[i]
          if (min > tableData.b[i]) min = tableData.b[i]
          if (min > tableData.c[i]) min = tableData.c[i]
          if (min > tableData.t[i]) min = tableData.t[i]
        }

        if (max > 1000 || min < -1000) {
          this.powerTrendOption.yAxis[0].name = 'MW'
          this.powerTrendOption.tooltip.formatter = function (params) {
            // var relVal = params[0].name
            var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'MW'
            }
            return relVal
          }
          for (let i = 0; i < res.data.p_pha.length; i++) {
            tableData.a[i] = tableData.a[i] * 0.001
            tableData.b[i] = tableData.b[i] * 0.001
            tableData.c[i] = tableData.c[i] * 0.001
            tableData.t[i] = tableData.t[i] * 0.001
          }
        } else {
          this.powerTrendOption.yAxis[0].name = 'kW'
          this.powerTrendOption.tooltip.formatter = function (params) {
            // var relVal = params[0].name
            var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'kW'
            }
            return relVal
          }
        }
      } else if (this.powerTypeSelectValue === 2) {
        tableData.a = res.data.q_pha
        tableData.b = res.data.q_phb
        tableData.c = res.data.q_phc
        tableData.t = res.data.q_total

        for (let i = 0; i < res.data.p_pha.length; i++) {
          if (max < tableData.a[i]) max = tableData.a[i]
          if (max < tableData.b[i]) max = tableData.b[i]
          if (max < tableData.c[i]) max = tableData.c[i]
          if (max < tableData.t[i]) max = tableData.t[i]
          if (min > tableData.a[i]) min = tableData.a[i]
          if (min > tableData.b[i]) min = tableData.b[i]
          if (min > tableData.c[i]) min = tableData.c[i]
          if (min > tableData.t[i]) min = tableData.t[i]
        }

        if (max > 1000 || min < -1000) {
          this.powerTrendOption.yAxis[0].name = 'MVar'
          this.powerTrendOption.tooltip.formatter = function (params) {
            var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'MVar'
            }
            return relVal
          }
          for (let i = 0; i < res.data.p_pha.length; i++) {
            tableData.a[i] = tableData.a[i] * 0.001
            tableData.b[i] = tableData.b[i] * 0.001
            tableData.c[i] = tableData.c[i] * 0.001
            tableData.t[i] = tableData.t[i] * 0.001
          }
        } else {
          this.powerTrendOption.yAxis[0].name = 'kVar'
          this.powerTrendOption.tooltip.formatter = function (params) {
            var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'kVar'
            }
            return relVal
          }
        }
      } else if (this.powerTypeSelectValue === 3) {
        tableData.a = res.data.s_pha
        tableData.b = res.data.s_phb
        tableData.c = res.data.s_phc
        tableData.t = res.data.s_total

        for (let i = 0; i < res.data.p_pha.length; i++) {
          if (max < tableData.a[i]) max = tableData.a[i]
          if (max < tableData.b[i]) max = tableData.b[i]
          if (max < tableData.c[i]) max = tableData.c[i]
          if (max < tableData.t[i]) max = tableData.t[i]
          if (min > tableData.a[i]) min = tableData.a[i]
          if (min > tableData.b[i]) min = tableData.b[i]
          if (min > tableData.c[i]) min = tableData.c[i]
          if (min > tableData.t[i]) min = tableData.t[i]
        }

        if (max > 1000 || min < -1000) {
          this.powerTrendOption.yAxis[0].name = 'MVA'
          this.powerTrendOption.tooltip.formatter = function (params) {
            var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'MVA'
            }
            return relVal
          }
          for (let i = 0; i < res.data.p_pha.length; i++) {
            tableData.a[i] = tableData.a[i] * 0.001
            tableData.b[i] = tableData.b[i] * 0.001
            tableData.c[i] = tableData.c[i] * 0.001
            tableData.t[i] = tableData.t[i] * 0.001
          }
        } else {
          this.powerTrendOption.yAxis[0].name = 'kVA'
          this.powerTrendOption.tooltip.formatter = function (params) {
            var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'kVA'
            }
            return relVal
          }
        }
      }
      if (res.data.p_pha.length < 97) {
        var j = res.data.p_pha.length
        for (var i = 0; i < (96 - j); i++) {
          tableData.a[j + i] = 0
          tableData.b[j + i] = 0
          tableData.c[j + i] = 0
          tableData.t[j + i] = 0
        }
      }

      this.powerTrendOption.series[0].data = tableData.a.reverse()
      this.powerTrendOption.series[1].data = tableData.b.reverse()
      this.powerTrendOption.series[2].data = tableData.c.reverse()
      this.powerTrendOption.series[3].data = tableData.t.reverse()
      this.powerTrendChart.setOption(this.powerTrendOption)
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">24小时功率趋势图界面</div>

      <div style="width: 100%; display: flex;">
        <!--        <div-->
        <!--          style="width: 230px; display: flex; align-items: center; margin-left: 20px; justify-content: space-around">-->
        <!--          <div>相/总功率</div>-->
        <!--          <div style="width: 150px">-->
        <!--            <el-select v-model="powerSelectValue" placeholder="请选择">-->
        <!--              <el-option-->
        <!--                v-for="item in powerSelectOptions"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value">-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </div>-->
        <!--        </div>-->
        <div
          style="width: 40%; display: flex; align-items: center; margin-left: 20px;">
          <div>功率类型</div>
          <div style="width: 120px; margin-left: 20px">
            <el-select v-model="powerTypeSelectValue" placeholder="请选择" size="20px">
              <el-option
                v-for="item in powerTypeSelectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div style="height: calc(100% - 70px);">
        <div id="powerTrendChartOptions" style="height: 100%; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.pg {
  height: calc(45vh - 50px);
}

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/PowerTrend/PowerTrend.vue